// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import { JobOffer } from 'apps/job_offers/models/job_offer';
import http from './http';
import { Activity } from 'apps/activities/models/activity';
import { JobApplication } from 'apps/job_applications/models/job_application';
import { BookmarkedOffer } from 'apps/bookmarked_offers/models/bookmarked_offer';
import { ApplicantUser } from 'apps/applicants/models/applicant';
import { CompanyUser } from 'apps/companies/models/company';


class ApiService {

    // Login
    async login(formData) {
        let result = await http.post('login/', {...formData });
        return result;
    }

    // Logout
    async logout() {
        let result = await http.post('logout/');
        return result.data;
    }

    // Get Activities
    async getActivities() {
        let result = await http.get('activities/');       
        return result.data.map((data) => new Activity(data));
    } 

    // Get Latest Activities
    async getLatestActivities() {
        let result = await http.get('latest-activities/');       
        return result.data.map((data) => new Activity(data));
    } 

    // Check Applicant
    async checkApplicant(fiscalCode) {
        let result = await http.get(`applicants/${fiscalCode}/`);
        return result.data;
    }
    
    // Check Company
    async checkCompany(fiscalCode) {
        let result = await http.get(`companies/${fiscalCode}/`);
        return result.data;
    }

    // Job Modes List
    async getJobModes() {
        let result = await http.get('assets/job-modes/');
        return result.data;
    }

    // CP 2021 List
    async getCP2021() {
        let result = await http.get('assets/cp2021/');
        return result.data;
    }

    // CP 2021 Macrocategories List
    async getCP2021Macrocategories() {
        let result = await http.get('assets/cp2021-macrocategories/');
        return result.data;
    }

    // CP 2021 Filtered Categories List
    async getCP2021FilteredCategories(category, search = "", limit = 50, offset = 0) {
        const params = new URLSearchParams({ search, limit, offset }).toString();
        const result = await http.get(`assets/cp2021-filters/${category}?${params}`);
        return result.data;
    }

    // CP 2021 Single Category
    async getCP2021SingleCategory(category) {
        let result = await http.get(`assets/cp2021-single-category/${category}/`);
        return result.data;
    }

    // Genders List
    async getGenders() {
        let result = await http.get('assets/genders/');
        return result.data;
    }

    // Citizenships List
    async getCitizenships() {
        let result = await http.get('assets/citizenships/');
        return result.data;
    }

    // Provinces List
    async getProvinces() {
        let result = await http.get('assets/provinces/');
        return result.data;
    }

    // Nations List
    async getNations() {
        let result = await http.get('assets/nations/');
        return result.data;
    }

    // Get Foreign Cities By Nation List
    async getForeignCitiesByNation(nation) {
        let result = await http.get(`assets/foreign-cities-by-nation/${nation}/`);
        return result.data;
    }

    // Get Cities By Province List
    async getCitiesByProvince(province) {
        let result = await http.get(`assets/cities-by-province/${province}/`);
        return result.data;
    }

    // Get Protected Classes List
    async getProtectedClasses() {
        let result = await http.get('assets/protected-classes/');
        return result.data;
    }

    // Get Languages List
    async getLanguages() {
        let result = await http.get('assets/languages/');
        return result.data;
    }

    // Get Contract Types List
    async getContractTypes() {
        let result = await http.get('assets/contract-types/');
        return result.data;
    }

    // Get Study Titles Macrocategories List
    async getStudyTitlesMacroCategories() {
        let result = await http.get('assets/study-titles-macrocategories/');
        return result.data;
    }

    // Get Study Titles Filtered Categories List
    async getStudyTitlesFilteredCategories(category) {
        let result = await http.get(`assets/study-titles-filters/${category}/`);
        return result.data;
    }

    // Get EQF List
    async getEQF() {
        let result = await http.get('assets/eqf/');
        return result.data;
    }

    // Get Durations List
    async getDurations() {
        let result = await http.get('assets/durations/');
        return result.data;
    }

    // Get Final Certifications List
    async getFinalCertifications() {
        let result = await http.get('assets/final-certifications/');
        return result.data;
    }

    // Get Language Levels By Type List
    async getLanguageLevelsByType(type) {
        let result = await http.get(`assets/language-levels-by-type/${type}/`);
        return result.data;
    }

    // Get Digital Skills List
    async getDigitalSkills() {
        let result = await http.get('assets/digital-skills/');
        return result.data;
    }

    // Get Licenses List
    async getLicenses() {
        let result = await http.get('assets/licenses/');
        return result.data;
    }

    // Get Registers List
    async getRegisters() {
        let result = await http.get('assets/registers/');
        return result.data;
    }

    // Get Professional Orders List
    async getProfessionalOrders() {
        let result = await http.get('assets/professional-orders/');
        return result.data;
    }

    // Get Experience Levels List
    async getExperienceLevels() {
        let result = await http.get('assets/experience-levels/');
        return result.data;
    }

    // Register Applicant
    async registerApplicant(formData) {
        let result = await http.post('applicants/', {...formData });
        return result;
    }

    // Edit Applicant
    async editApplicant(fiscal_code, formData) {
        let result = await http.patch(`applicants/${fiscal_code}/`, {...formData });
        return result;
    }

    // Delete Applicant
    async deleteApplicant(fiscal_code) {
        let result = await http.delete(`applicants/${fiscal_code}/`);
        return result;
    }

    // Get Applicants
    async getApplicants() {
        let result = await http.get('applicants/');        
        return result.data.map((data) => new ApplicantUser(data.user_data, data));
    } 

    // Get Latest Applicants
    async getLatestApplicants() {
        let result = await http.get('latest-applicants/');        
        return result.data.map((data) => new ApplicantUser(data.user_data, data));
    } 

    // Register Company
    async registerCompany(formData) {
        let result = await http.post('companies/', {...formData });
        return result;
    }

    // Edit Company
    async editCompany(fiscal_code, formData) {
        let result = await http.patch(`companies/${fiscal_code}/`, {...formData });
        return result;
    }

    // Delete Company
    async deleteCompany(fiscal_code) {
        let result = await http.delete(`companies/${fiscal_code}/`);
        return result;
    }

    // Get Companies
    async getCompanies() {
        let result = await http.get('companies/');        
        return result.data.map((data) => new CompanyUser(data.user_data, data));
    }

    // Get Waiting Companies Count
    async getWaitingCompaniesCount() {
        let result = await http.get('waiting-companies-count/');        
        return result.data;
    }

    // Get Latest Companies
    async getLatestCompanies() {
        let result = await http.get('latest-companies/');        
        return result.data.map((data) => new CompanyUser(data.user_data, data));
    }

    // Create Job Offer
    async createJobOffer(formData) {
        let result = await http.post('job_offers/', {...formData });
        return result;
    }

    // Edit Job Offer
    async editJobOffer(slug, formData) {
        let result = await http.patch(`job_offers/${slug}/`, {...formData });
        return result;
    }

    // Delete Job Offer
    async deleteJobOffer(slug) {
        let result = await http.delete(`job_offers/${slug}/`);
        return result;
    }

    // Get Job Offers 
    async getJobOffers() {
        let result = await http.get('job_offers/');
        return result.data.map((data) => new JobOffer(data));
    }

    // Job Offers By Company List
    async getJobOffersByCompany() {
        let result = await http.get('job-offers-by-company/');
        return result.data.map((data) => new JobOffer(data));
    }

    // Get Job Offer
    async getJobOffer(slug) {
        let result = await http.get(`job_offers/${slug}/`);        
        return new JobOffer(result.data);
    }

    // Get Latest Job Offers
    async getLatestJobOffers() {
        let result = await http.get('latest-job-offers/');        
        return result.data.map((data) => new JobOffer(data));
    }

    // Get All Job Offers
    async getJobOffersAdmin() {
        let result = await http.get('job-offers-admin-view/');        
        return result.data.map((data) => new JobOffer(data));
    }

    // Check Job Offer Owner
    async checkJobOfferOwner(slug) {
        let result = await http.get(`job-offers-by-company/${slug}/`);        
        return result.data;
    }

    // Apply to Job Offer
    async applyToJobOffer(formData) {
        let result = await http.post('job_applications/', {...formData });
        return result;
    }

    // Get Job Application By Job Offer
    async getJobApplicationByJobOffer(id) {
        let result = await http.get(`job-application-by-job-offer/${id}/`);
        return result.data;
    }

    // Get Job Applications
    async getJobApplications() {
        let result = await http.get('job_applications/');
        return result.data.map((data) => new JobApplication(data));
    }

    // Get Latest Job Applications
    async getLatestJobApplications() {
        let result = await http.get('latest-job-applications/');
        return result.data.map((data) => new JobApplication(data));
    }

    // Delete Job Applications
    async deleteJobApplication(id) {
        let result = await http.delete(`job_applications/${id}/`);
        return result;
    }

    // Add Job Offer to Bookmarks
    async addJobOfferToBookmarks(formData) {
        let result = await http.post('bookmarked_job_offers/', {...formData });
        return result;
    }

    // Remove Job Offer from Bookmarks
    async removeJobOfferFromBookmarks(id) {
        let result = await http.delete(`bookmarked_job_offers/${id}/`);
        return result;
    }

    // Get Bookmarked Offers
    async getBookmarkedOffers() {
        let result = await http.get('bookmarked_job_offers/');
        return result.data.map((data) => new BookmarkedOffer(data));
    }

    // Get Bookmarked Offer By Job Offer
    async getBookmarkedOfferByJobOffer(id) {
        let result = await http.get(`bookmarked-offer-by-job-offer/${id}/`);
        return result.data;
    }

    // Print Curriculum Vitae
    async printCurriculumVitae(id) {
        let result = await http.post('print-curriculum-vitae/', {
            job_application_id: id
        }, {
            responseType: 'blob'
        });
        return result;
    }

    // Export Applicants
    async exportApplicants() {
        const result = await http.get('export-applicants/', {
            responseType: 'blob',
        });
        return result;
    }

    // Export Job Offers
    async exportJobOffers() {
        const result = await http.get('export-job-offers/', {
            responseType: 'blob',
        });
        return result;
    }

}

export default new ApiService();


